import { Typography, Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "theme";
import {
  Event,
  Celebration,
  Business,
  Groups,
  TrendingUp
} from "@mui/icons-material"
import StarsIcon from '@mui/icons-material/Stars'; // Glamorous star icon  
import Person4Icon from '@mui/icons-material/Person4'; // Modern VIP individual  

import MosqueIcon from '@mui/icons-material/Mosque';
const OurServices = () => {
  const { t } = useTranslation();
  const eventServices = [
    {
      id: "01",
      title: t("corporateEvents"),
      description:
        t("corporateEventsDetails"),
      icon: <Business sx={{ fontSize: 32 }} />,
    },
    {
      id: "02",
      title: t("weddingTransportation"),
      description:
       t("weddingTransportationDetails"),
      icon: <Event sx={{ fontSize: 32 }} />,
    },
    {
      id: "03",
      title: t("religiousTravel"),
      description:
        t("religiousTravelDetails"),
      icon: <MosqueIcon sx={{ fontSize: 32 }} />,
    },
    {
      id: "04",
      title: t("specialCelebrations"),
      description:
        t("specialCelebrationsDetails"),
      icon: <Celebration sx={{ fontSize: 32 }} />,
    },
    {
      id: "05",
      title: t("conference&Seminars"),
      description:
        t("conference&SeminarsDetails"),
      icon: <Groups sx={{ fontSize: 32 }} />,
    },
    {
      id: "06",
      title: t("productLaunches"),
      description:
        t("productLaunchesDetails"),
      icon: <TrendingUp sx={{ fontSize: 32 }} />,
    },
    {
      id: "07",
      title: t("redCarpetEvents"),
      description:
        t("redCarpetEventsDetails"),
      icon: <StarsIcon sx={{ fontSize: 32 }} />,
    },
    {
      id: "08",
      title: t("vipDelegations"),
      description:
        t("vipDelegationsDetails"),
      icon: <Person4Icon sx={{ fontSize: 32 }} />,
    },
  ]

  return (
    <>
   <Box
        // id="our-services-section"
        sx={{
          py: { xs:10, md:15 },
        }}
      >
          <Box sx={{ textAlign: "center", mb: {xs: 8, md: 10 } }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
              <Box sx={{ width: 60, height: 2, bgcolor: "#FFCD00", mr: 2 }} />
              <Box
                sx={{
                  bgcolor: "rgba(82, 10, 118, 0.1)",
                  color: theme.palette.secondary.contrastText,
                  px: 3,
                  py: 1,
                  borderRadius: 5,
                  fontWeight: 600,
                  fontSize: "0.9rem",
                }}
              >
                {t("ourService")}
              </Box>
              <Box sx={{ width: 60, height: 2, bgcolor: "#FFCD00", ml: 2 }} />
            </Box>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2.5rem", md: "2.5rem" },
                color: theme.palette.secondary.contrastText,
                mb: 4,
                fontWeight: 800,
                lineHeight: 1.2,
              }}
            >
              {t("eventTransportationServices")}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "text.secondary",
                fontWeight: 400,
                lineHeight: 1.7,
                fontSize: "1rem",
                maxWidth: 700,
                mx: "auto",
              }}
            >
             {t("serviceDetails")}
            </Typography>
          </Box>

    <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
        {eventServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={3} key={service.id}>
            <Box sx={{ 
              bgcolor: "white",
              p: "24px",
              borderRadius: "20px",
              height: 180,
              textAlign:"center",
              border: "2px solid rgba(82, 10, 118, 0.1)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
              position: "relative",
              overflow: "hidden",
              willChange: "transform, box-shadow",
              '&:hover': {
                transform: "translateY(-5px) translateZ(0)",
                boxShadow: "0 10px 20px rgba(82, 10, 118, 0.1)",
                borderColor: "#520A76",
                '& .service-icon': {
                  color: "#FFCD00"
                }
              }
            }}>
              <Box 
                className="service-icon"
                sx={{
                  color: "#520A76",
                  mb: 3,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                {service.icon}
              </Box>

              <Typography sx={{fontSize:"16px", fontWeight: 700, color: theme.palette.secondary.contrastText, mb: 2 }}>
                {service.title}
              </Typography>

              <Typography sx={{ fontSize:"13.5px",color: "text.secondary" }}>
                {service.description}
              </Typography>

              {/* Progress indicator */}
              <Box sx={{ 
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: 4,
                bgcolor: "rgba(82, 10, 118, 0.1)",
              }}>
                <Box sx={{ 
                  height: "100%",
                  width: `${((index + 1) / eventServices.length) * 100}%`,
                  bgcolor: "#FFCD00",
                  transition: "width 0.3s ease"
                }} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      </Box>
    </>
  );
};

export default OurServices;
